// Server-side DataTables for add-ons index
$(document).on('turbolinks:load sprinkles:update', function() {
  var $serverTable = $('#add-ons-datatable');

  if ($serverTable.length === 0 || $serverTable.hasClass('dataTable')) {
    return; // Table doesn't exist or already initialized
  }

  var table = $serverTable.DataTable({
    "processing": true,
    "serverSide": true,
    "ajax": {
      "url": $serverTable.data('source')
    },
    "pagingType": "full_numbers",
    "pageLength": 25,
    "order": [[1, "desc"]], // Sort by created_at descending (column 1: sort_column)
    "autoWidth": false, // Prevent DataTables from calculating column widths
    "columns": [
      {"data": "row_html", "orderable": false, "width": "100%"}, // Single visible column with full row HTML
      {"data": "sort_column", "visible": false, "orderable": true},
      {"data": "type_name", "visible": false},
      {"data": "last_accessed_int", "visible": false},
      {"data": "disabled", "visible": false},
      {"data": "premium", "visible": false}
    ],
    "createdRow": function(row, data, dataIndex) {
      // Replace the row content with the full HTML from the partial
      // The partial renders a complete <tr> with multiple <td> elements
      // We need to extract all the cells and insert them into our row
      var $tempRow = $(data.row_html);

      // Clear ALL cells that DataTables created (it creates one per column definition)
      $(row).empty();

      // Copy all the <td> elements from the partial into our row
      $tempRow.find('td').each(function() {
        $(row).append($(this).clone());
      });

      $(row).attr('data-id', data.DT_RowId);
      $(row).addClass('add-on-instance');
    }
  }).on('draw.dt', function() {
    $('[data-toggle="tooltip"]').tooltip();
  });

  // Connect filters to DataTables
  // Note: Column mapping has changed:
  // 0: row_html (visible)
  // 1: sort_column (hidden, for sorting)
  // 2: type_name (hidden, for filtering)
  // 3: last_accessed_int (hidden, for filtering)
  // 4: disabled (hidden, for filtering)
  // 5: premium (hidden, for filtering)

  $('[data-filter-col]').on('change keyup', function() {
    var colIdx = $(this).data('filter-col');
    var value = $(this).val();

    if (value === '--any--') {
      value = '';
    }

    // Map the old column indices to new ones
    // Old col 1 (name search) -> now searches col 2 (type_name)
    if (colIdx == 1) {
      // Search in the visible row HTML content instead
      table.search(value).draw();
      return;
    }

    table.column(colIdx).search(value).draw();
  });

  // Multi-filter support
  $('[data-multi-filter]').on('change', function() {
    var selectedFilters = $(this).val() || [];

    // Clear all searches first
    table.columns().search('');

    selectedFilters.forEach(function(filter) {
      var parts = filter.split(':');
      var colIdx = parseInt(parts[1]);
      var filterType = parts[2];
      var filterValue = parts[3];

      if (filterType === 'text') {
        table.column(colIdx).search(filterValue);
      } else if (filterType === 'num') {
        // For numeric ranges, search the column
        table.column(colIdx).search(filterValue);
      }
    });

    table.draw();
  });
});
